import { render, staticRenderFns } from "./otcWalletRecord.vue?vue&type=template&id=222a4740&scoped=true&"
import script from "./otcWalletRecord.vue?vue&type=script&lang=js&"
export * from "./otcWalletRecord.vue?vue&type=script&lang=js&"
import style0 from "./otcWalletRecord.vue?vue&type=style&index=0&id=222a4740&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222a4740",
  null
  
)

export default component.exports